import classNames from 'classnames'
import Dropzone from 'react-dropzone'

import type { ReactElement, ReactNode, RefObject } from 'react'
import type { Accept, DropzoneRef, FileWithPath } from 'react-dropzone'

import MwMLoader from '~/components/MwMLoader'

import './styles.scss'

export interface Props {
  accept?: Accept
  className?: string
  dropzoneRef?: RefObject<DropzoneRef>
  icon?: ReactNode
  isLoading?: boolean
  multiple?: boolean
  noClick?: boolean
  onDrop?: (files: FileWithPath[]) => void
  onFileDialogCancel?: VoidFunction
  onFileDialogOpen?: VoidFunction
}

const CustomDropzone = ({
  accept,
  className,
  dropzoneRef,
  icon,
  isLoading,
  multiple,
  noClick,
  onDrop,
  onFileDialogCancel,
  onFileDialogOpen,
}: Props): ReactElement => {
  return (
    <Dropzone
      accept={accept}
      multiple={multiple}
      noClick={noClick}
      onDrop={onDrop}
      onFileDialogCancel={onFileDialogCancel}
      onFileDialogOpen={onFileDialogOpen}
      ref={dropzoneRef}
    >
      {({ getInputProps, getRootProps, isDragAccept, isDragReject }) => (
        <div
          className={classNames('dropzone-component', className, {
            'dropzone-component--drag-accept': isDragAccept,
            'dropzone-component--drag-reject': isDragReject,
          })}
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          {isLoading ? (
            <MwMLoader category="item" />
          ) : (
            <>
              <div className="instructions-container">
                <div>Drag & drop your file{multiple && '(s)'}</div>
                <div className="instruction">
                  or <span className="emphasis">browse</span>
                </div>
              </div>
              {icon}
            </>
          )}
        </div>
      )}
    </Dropzone>
  )
}

export default CustomDropzone
